module.exports = "<svg viewBox=\"0 0 12 12\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M11.43 7.4H0V4.624H11.43\" fill=\"#13475E\"></path></svg>"